<template>
  <div class="checkout">
    <h1>付款頁面</h1>
    <div class="checkout__container">
      <!-- order info -->
      <transition name="fade">
        <div class="checkout__block">
          <p
            class="checkout__title checkout__title--collapse"
            :class="orderInfoCollapse ? null : 'collapsed'"
            :aria-expanded="orderInfoCollapse ? 'true' : 'false'"
            aria-controls="collapse__orderInfo"
            @click.prevent="orderInfoCollapse = !orderInfoCollapse"
          >
            <span>訂單詳細資料</span>
          </p>
          <b-collapse id="collapse__orderInfo" v-model="orderInfoCollapse">
            <div class="checkout__body">
              <div class="showInfo">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    訂單
                  </div>
                  <div class="showInfo__body">
                    <ul class="showInfo__list">
                      <li class="showInfo__item">
                        <p class="showInfo__key">訂單編號</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.id}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">建立訂單時間</p>
                        <div class="showInfo__value">
                          <p>{{convert_time(thisOrder.createTime)}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="showInfo">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    訂單內容
                  </div>
                  <div class="showInfo__body">
                    <cart-content :editable="false" :connectObj="thisOrder.cart"></cart-content>
                  </div>
                </div>
              </div>
              <div class="showInfo">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    結帳金額
                  </div>
                  <div class="showInfo__body">
                    <ul class="showInfo__list">
                      <li class="showInfo__item">
                        <p class="showInfo__key">小計</p>
                        <div class="showInfo__value">
                          <p>NT $ {{thisOrder.cart.sum}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">使用優惠券</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.coupon.id}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">優惠券折扣</p>
                        <div class="showInfo__value">
                          <p>NT $ {{thisOrder.coupon.discount}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">總金額</p>
                        <div class="showInfo__value">
                          <p>NT $ {{thisOrder.sum}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="showInfo">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    訂購人
                  </div>
                  <div class="showInfo__body">
                    <ul class="showInfo__list">
                      <li class="showInfo__item">
                        <p class="showInfo__key">姓名</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.buyer.name}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">電話</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.buyer.tel}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">電子信箱</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.buyer.email}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="showInfo">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    發票
                  </div>
                  <div class="showInfo__body">
                    <ul class="showInfo__list">
                      <li class="showInfo__item">
                        <p class="showInfo__key">發票類型</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.invoice.type)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="thisOrder.invoice.type === 'person'">
                        <p class="showInfo__key">載具類型</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.invoice.personCarrier)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item" v-if="thisOrder.invoice.type === 'person'">
                        <div class="showInfo__item"
                        v-if="thisOrder.invoice.personCarrier === 'no'">
                          <p class="showInfo__key">中獎發票寄送地址</p>
                          <div class="showInfo__value">
                            <p>{{thisOrder.invoice.personCarrierAddress}}</p>
                          </div>
                        </div>
                      </li>
                      <li class="showInfo__item" v-if="thisOrder.invoice.type === 'person'">
                        <div class="showInfo__item"
                        v-if="thisOrder.invoice.personCarrier === 'mobile'">
                          <p class="showInfo__key">手機條碼</p>
                          <div class="showInfo__value">
                            <p>{{thisOrder.invoice.personCarrierMobile}}</p>
                          </div>
                        </div>
                      </li>
                      <li class="showInfo__item" v-if="thisOrder.invoice.type === 'person'">
                        <div class="showInfo__item"
                        v-if="thisOrder.invoice.personCarrier === 'nature'">
                          <p class="showInfo__key">自然人憑證條碼</p>
                          <div class="showInfo__value">
                            <p>{{thisOrder.invoice.personCarrierNature}}</p>
                          </div>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="thisOrder.invoice.type === 'donation'">
                        <p class="showInfo__key">捐贈單位</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.invoice.donationTarget)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="thisOrder.invoice.type === 'company'">
                        <p class="showInfo__key">買受人</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.invoice.companyTitle}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="thisOrder.invoice.type === 'company'">
                        <p class="showInfo__key">統一編號</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.invoice.companyId}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="showInfo">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    配送資訊
                  </div>
                  <div class="showInfo__body">
                    <ul class="showInfo__list">
                      <li class="showInfo__item">
                        <p class="showInfo__key">是否門市取貨</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.recipient.ifGetFromStore)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="!thisOrder.recipient.ifGetFromStore">
                        <p class="showInfo__key">收貨人姓名</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.recipient.info.name}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="!thisOrder.recipient.ifGetFromStore">
                        <p class="showInfo__key">收貨人聯絡電話</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.recipient.info.tel}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="!thisOrder.recipient.ifGetFromStore">
                        <p class="showInfo__key">配送地址</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.recipient.info.address}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="!thisOrder.recipient.ifGetFromStore">
                        <p class="showInfo__key">收件地址是否有櫃檯或管理員可以代收?</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.recipient.info.ifRepresentative)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="!thisOrder.recipient.ifGetFromStore">
                        <div class="showInfo__item"
                        v-if="thisOrder.recipient.info.ifRepresentative">
                          <p class="showInfo__key">代收公司 / 大樓或社區名稱</p>
                          <div class="showInfo__value">
                            <p>{{thisOrder.recipient.info.representativeTitle}}</p>
                          </div>
                        </div>
                      </li>
                      <li class="showInfo__item"
                      v-if="!thisOrder.recipient.ifGetFromStore">
                        <p class="showInfo__key">匿名配送</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.recipient.info.ifAnonymous)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">希望到貨日期</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.recipient.esdDate}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">希望到貨時間</p>
                        <div class="showInfo__value">
                          <p>{{convert_text(thisOrder.recipient.esdTime)}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">卡片內容</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.recipient.cardContent}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">備註</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.recipient.remark}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </transition>
      <!-- payment info -->
      <transition name="fade">
        <div class="checkout__block">
          <p class="checkout__title checkout__title--collapse"
            :class="paymentInfoCollapse ? null : 'collapsed'"
            :aria-expanded="paymentInfoCollapse ? 'true' : 'false'"
            aria-controls="collapse__orderInfo"
            @click.prevent="paymentInfoCollapse = !paymentInfoCollapse">
            <span>付款方式</span>
          </p>
          <b-collapse id="collapse__orderInfo" v-model="paymentInfoCollapse">
            <div class="checkout__body">
              <div class="showInfo" v-if="!thisOrder.payment.ifPaid">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    信用卡付款
                  </div>
                  <div class="showInfo__body">
                    <div class="payment">
                      <p class="payment__sum">
                        總應付金額: NT${{thisOrder.sum}}
                      </p>
                      <form @submit.prevent="pay_order">
                        <div class="myForm">
                          <span class="myForm__title">信用卡號</span>
                          <input class="form-control"
                          type="text" required v-model="payment.creditNumber">
                        </div>
                        <div class="myForm">
                          <span class="myForm__title">信用卡有效月 / 年</span>
                          <div class="myForm__inputRow">
                            <input class="form-control" type="text" placeholder="月" required
                            v-model="payment.creditExp.month">
                            <input class="form-control" type="text" placeholder="年" required
                            v-model="payment.creditExp.year">
                          </div>
                        </div>
                        <div class="myForm">
                          <span class="myForm__title">背面末三碼</span>
                          <input class="form-control" type="text" placeholder="cvc" required
                          v-model="payment.creditCvc">
                        </div>
                        <div class="myForm">
                          <div class="myForm__submit">
                            <button type="submit">
                              確認付款
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div class="showInfo" v-if="thisOrder.payment.ifPaid">
                <div class="showInfo__block">
                  <div class="showInfo__title">
                    付款資訊
                  </div>
                  <div class="showInfo__body">
                    <ul class="showInfo__list">
                      <li class="showInfo__item">
                        <p class="showInfo__key">已付款時間</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.payment.info.time}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">付款方式</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.payment.info.type}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">信用卡號</p>
                        <div class="showInfo__value">
                          <p>{{thisOrder.payment.info.creditNumber}}</p>
                        </div>
                      </li>
                      <li class="showInfo__item">
                        <p class="showInfo__key">結帳金額</p>
                        <div class="showInfo__value">
                          <p>NT${{thisOrder.sum}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CartContent from '../../components/CartContent.vue';

export default {
  components: { CartContent },
  computed: {
    orders() {
      let orders = [];
      this.$bus.$on('son_get_data', (data) => {
        orders = data.orders;
      });
      this.$bus.$emit('son_call_data');
      return orders;
    },
    orderId() {
      return this.$route.params.orderId;
    },
    thisOrder() {
      return this.orders.find((item) => item.id === this.orderId);
    },
  },
  data() {
    return {
      orderInfoCollapse: true,
      paymentInfoCollapse: true,
      payment: {},
    };
  },
  methods: {
    convert_time(createTime) {
      const theDate = new Date(createTime);
      const year = theDate.getFullYear();
      const month = theDate.getMonth() + 1;
      const day = theDate.getDate();
      const hour = theDate.getHours();
      const minute = theDate.getMinutes();
      const second = theDate.getSeconds();
      const twoDigits = (num) => (num > 9 ? '' : '0') + num;
      const timeStr = `${year}-${twoDigits(month)}-${twoDigits(day)} ${twoDigits(hour)}:${twoDigits(minute)}:${twoDigits(second)}`;
      return timeStr;
    },
    convert_text(value) {
      let text = '';
      switch (value) {
        case 'person':
          text = '個人電子發票';
          break;
        case 'donation':
          text = '捐贈電子發票';
          break;
        case 'company':
          text = '公司報帳電子發票';
          break;
        case 'no':
          text = '不使用載具';
          break;
        case 'mobile':
          text = '手機條碼載具';
          break;
        case 'nature':
          text = '自然人憑證載具';
          break;
        case 'donationComapny1':
          text = '捐贈單位1';
          break;
        case 'donationCompany2':
          text = '捐贈單位2';
          break;
        case 'donationCompany3':
          text = '捐贈單位3';
          break;
        case true:
          text = '是';
          break;
        case false:
          text = '否';
          break;
        case '':
          text = '不指定';
          break;
        case 'morning':
          text = '上午( 08:00 ~ 13:00 )';
          break;
        case 'afternoon':
          text = '下午( 14:00 ~ 18:00 )';
          break;
        default:
          break;
      }
      return text;
    },
    get_paymentInfoType(value) {
      const newObj = {};
      switch (value) {
        case 'creditCard':
          newObj.type = value;
          newObj.creditNumber = '';
          newObj.creditExp = {
            month: '',
            year: '',
          };
          newObj.creditCvc = '';
          break;
        default:
          break;
      }
      this.$set(this, 'payment', newObj);
    },
    pay_order() {
      this.payment.time = this.convert_time(new Date());
      this.$bus.$emit('make_payment', this.thisOrder.id, this.payment);
    },
  },
  created() {
    const createPaymentInfo = () => {
      const ifPaidBoolean = this.thisOrder.payment.ifPaid;
      const newPaymentInfoObj = {
        type: '',
      };
      if (!ifPaidBoolean) {
        this.$set(this.thisOrder.payment, 'info', newPaymentInfoObj);
      }
    };
    createPaymentInfo();
    // 暫定付款方式只有信用卡
    this.get_paymentInfoType('creditCard');
  },
};
</script>
